import React, { useState } from "react";
import { useNavigate } from "react-router-dom"; // React Router hook for navigation
// import { useAuth } from '../components/AuthContext'
const OtpVerification = ({ setIsVerified }) => {
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [generatedOtp, setGeneratedOtp] = useState(null);
  const [message, setMessage] = useState({ text: "", type: "" });
  const navigate = useNavigate(); // Hook for navigation
  // const token = localStorage.getItem('authToken')
  // const { login } = useAuth()

  // Function to simulate sending OTP
  const handleSendOtp = () => {
    if (!phone) {
      return setMessage({
        text: "Please enter your phone number",
        type: "error",
      });
    }

    // Simulate OTP generation and sending
    const newOtp = generateOtp();
    setGeneratedOtp(newOtp);
    setMessage({
      text: `OTP has been generated. Enter it to verify.`,
      type: "success",
    });
  };

  // src/otpUtils.js
  const generateOtp = () => {
    const otp = Math.floor(100000 + Math.random() * 900000); // Generates a 6-digit OTP
    return otp.toString();
  };

  // Function to verify OTP
  const handleVerifyOtp = () => {
    if (!otp) {
      return setMessage({ text: "Please enter the OTP", type: "error" });
    }

    if (otp === generatedOtp) {
      setMessage({
        text: "✅ OTP verified successfully",
        type: "success",
      });
      navigate("/");
    } else {
      setMessage({
        text: "Invalid OTP. Please try again",
        type: "error",
      });
    }
  };

  return (
    <div
      style={{
        // marginTop: 200,
        maxWidth: 400,
        margin: "auto",
        padding: 20,
        fontFamily: "Arial",
      }}
    >
      <div className="mt-56"></div>
      <h2>Phone OTP Verification</h2>
      <input
        type="text"
        placeholder="Enter your phone number"
        value={phone}
        onChange={(e) => setPhone(e.target.value)}
        disabled={generatedOtp !== null} // Disable input after OTP is generated
      />
      <button
        onClick={handleSendOtp}
        style={buttonStyle}
        disabled={generatedOtp !== null}
      >
        Send OTP
      </button>

      {generatedOtp && (
        <div style={{ marginTop: 20 }}>
          <p>
            <strong>Generated OTP: </strong>
            {generatedOtp}
          </p>{" "}
          {/* Display OTP on page */}
          <input
            type="text"
            placeholder="Enter OTP"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
          />
          <button onClick={handleVerifyOtp} style={buttonStyle}>
            Verify OTP
          </button>
        </div>
      )}

      {message.text && (
        <div
          style={{
            marginTop: 10,
            color: message.type === "error" ? "red" : "green",
          }}
        >
          {message.text}
        </div>
      )}
    </div>
  );
};

const buttonStyle = {
  marginTop: 10,
  padding: 10,
  width: "100%",
  backgroundColor: "#4285f4",
  color: "white",
  border: "none",
  cursor: "pointer",
};

export default OtpVerification;
